export default import.meta.ROLLDOWN_FILE_URL_tRJNOt1YOVdI8OrEQYtO2A